import * as React from 'react'
import { ValueContainerProps, components } from 'react-select'
import { UserOption } from '../user-select.types'

export const ValueContainer = (props: ValueContainerProps<UserOption>) => (
  <components.ValueContainer {...props} className="py-1 min-h-[40px] gap-y-2" />
)
